import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Subject } from "rxjs";
import { FillOrderData } from "..";
export const CHANNEL_FILL_TOLERANCE_SERVICE: string = "FillToleranceServiceChannel";

export interface DetailFillToleranceResponse {
  origRequest: Array<FillOrderData>;
  failedIds: Array<{ orderId: string; orderRef: string; error: string }>;
}

export interface IFillToleranceService {}
